import React from 'react';
import { connectMenu } from 'react-instantsearch-core';
import { brandShape } from 'shapes';

const VirtualMenu = connectMenu(() => null);

export default function BrandLocker({ brand }) {
    return (
        <VirtualMenu attribute="brand_name" defaultRefinement={brand.name} />
    );
}

BrandLocker.propTypes = {
    brand: brandShape.isRequired,
};
